<p-toast></p-toast>
<div class="card mt-2" *ngIf="listImagePathJE && listImagePathJE.length > 0 && showListImageJE && !isDDAssociate">
    <h5 class="mt-0">{{'JE_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathJE; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'JE')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2" *ngIf="listImagePathSDO && listImagePathSDO.length > 0 && showListImageSDO && !isDDAssociate">
    <h5 class="mt-0">{{'SDO_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathSDO; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'SDO')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2" *ngIf="listImagePathXEN && listImagePathXEN.length > 0 && showListImageXEN && !isDDAssociate">
    <h5 class="mt-0">{{'XEN_ATTACHMENTS'| translate}}</h5>
    <div class="p-fluid p-formgrid grid">
        <div *ngFor="let image of listImagePathXEN; let index = index;" class="field m-3"
            key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer"
                (click)="imageClick(index, 'XEN')" style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-center">
                <div>{{image.DocumentType}}</div>
            </div>
        </div>
    </div>
</div>

<div class="card mt-2" *ngIf="editBilledData && !isRPCase">
    <h5 class="mt-0">{{'UPLOAD_ATTACHMENT'| translate}}</h5>
    <div class="flex flex-wrap justify-content-center">
        <div class="m-2">
            <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="Choose Document Type"
                optionLabel="name" [showClear]="true"></p-dropdown>

        </div>
        <div class="m-2">
            <button (click)="openCamera()" pButton pRipple type="button" label="Capture" [disabled]="!selctedFileType"
                class="p-button-success mr-2 mb-2"></button>
        </div>
    </div>
    <div>
        <div>
            <div>
                <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                    <div class="document p-fluid p-formgrid grid mt-5" *ngFor="let item of documentList; let i=index">
                        <div>
                            <span style="display: flex; justify-content: space-around">
                                {{i+1}}
                                <br>
                                <p style="margin-bottom: 0;"  target="_blank"> {{item.name ? item.name: item.DocumentType}}</p>
                                <!-- <p style="margin-bottom: 0;" target="_blank"> {{item.name}}</p> -->
                                <i class="pi pi-times cross-icon" (click)="removeCaptureImg(i)"></i>
                            </span>
                            <img [src]="item.attachmentRawUrl ? item.attachmentRawUrl:item.ImagePath"
                                style="max-width: 300px; max-height: 300px; display: block;">
                        </div>
                        <!-- <div class="description">
                            
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="card mt-3 flex justify-content-between">
    <button (click)="onAttachmentsFormGoBack()" pButton pRipple type="button" label="Back"
        class="p-button-success mr-2 mb-2"></button>
    <div>
        <button (click)="onAttachmentDetailsFormSubmit()" pButton pRipple type="button" label="Approve"
            class="p-button-success mr-2 mb-2" [disabled]="!documentList.length"></button>
    </div>
</div> -->

<p-galleria [value]="listImagePathJE" [(visible)]="displayCustomJE" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
    <!-- <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.ImagePath" style="display: block;" />
        </div>
    </ng-template> -->
</p-galleria>

<p-galleria [value]="listImagePathSDO" [(visible)]="displayCustomSDO" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>

<p-galleria [value]="listImagePathXEN" [(visible)]="displayCustomXEN" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>

<p-galleria [value]="images" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}" [circular]="true"
    [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="100000">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.ImagePath" style="width: 100%; display: block;" />
    </ng-template>
    <!-- <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.ImagePath" style="display: block;" />
        </div>
    </ng-template> -->
</p-galleria>

<!-- <div class="card" *ngIf="images.length">
    <h5 class="mt-0">{{'PREVIOUS_ATTACHMENTS'| translate}}</h5>
    <div *ngIf="images" class="p-fluid p-formgrid grid">
        <div *ngFor="let image of images; let index = index;" class="field m-3" key="index">
            <img [src]="image.ImagePath" [alt]="image.DocumentType" style="cursor: pointer" (click)="imageClick(index, 'PA')"
                style="max-width: 300px; max-height: 300px;" />
            <div class="flex flex-wrap justify-content-between">
                <div>{{image.DocumentType}}</div>
                <i class="pi pi-times cross-icon" (click)="removeCaptureImg('1')"></i>
            </div>
        </div>
    </div>
</div> -->

<div class="card" reflow="true" *ngIf="userRole == 'DMICADA' || userRole == 'ADMIN'">
    <div *ngIf="viewWorkFlowAllStatus">
        <app-work-flow-all-status [applicationId]="appId" ></app-work-flow-all-status>
    </div>

    <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
        class="p-button-secondary" (click)="workFlowAllStatus()"></button>
</div>

<div class="card mt-2">
    <div *ngIf="ddmiLogin" class="card app-details-card flex justify-content-center p-fluid p-formgrid grid">
        <div class="field col-12 md:col-3">
            <label htmlFor="farmerName">{{'APPLICATION_NO'| translate}}</label>
            <input readonly value="{{miPhysicalApplicationData?.AppID}}" pInputText id="farmerName"
                type="text" />
        </div>
        <div class="field col-12 md:col-3">
            <label htmlFor="farmerName">{{'FARMER_NAME'| translate}}</label>
            <input readonly value="{{miPhysicalApplicationData?.FarmerName}}" pInputText
                id="farmerName" type="text" />
        </div>
        <div class="field col-12 md:col-3">
            <label htmlFor="XENName">{{'DA_NAME'| translate}}</label>
            <input readonly value="{{miPhysicalApplicationData?.DAName}}" pInputText id="DAName"
                type="text" />
        </div>
        <div class="field col-12 md:col-3">
            <label htmlFor="DARemarks">{{'DA_REMARKS'| translate}}</label>
            <input readonly value="{{miPhysicalApplicationData?.DARemarks}}" pInputText id="DARemarks"
                type="text" />
        </div>                      
    </div>
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right" class="p-fluid p-formgrid grid">
            <div class="p-fluid p-formgrid grid">
                <div class="col-12 md:col-6">
                    <p-dropdown [disabled]="isRPCase" [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3" (onChange)="onSelectStatus()">
                    </p-dropdown>
                </div>
                <div class="col-12 md:col-6">
                    <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                        rows="3" cols="20" class="mr-3"></textarea>
                </div>
                <div class="col-12 md:col-4">
                    <button pButton pRipple label="Submit" (click)="onAttachmentDetailsFormSubmit()"
                        class="p-button-help"></button>
                </div>
            </div>
        </ng-template>
    </p-toolbar>
</div>

<p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
    [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseDialog()">
    <div *ngIf="displayCameraComponent">
        <div class="camera-container">
            <div *ngIf="locationError" style="color: red; font-weight: bold;">
                {{locationError}}
            </div>
            <div *ngIf="!imageCaptured">
                <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                    [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                    [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                    (initError)="handleInitError($event)"></webcam>
                <br />
            </div>

            <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
            <ul *ngFor="let error of errors">
                <li>{{error | json}}</li>
            </ul>
        </div>
        <div class="webcam-btn" *ngIf="!imageCaptured">
            <button pButton pRipple type="button" label="capture" class="p-button-success m-2"
                (click)="triggerSnapshot()"></button>
            <button pButton pRipple type="button" label="switch camera" class="p-button-success m-2"
                (click)="showNextWebcam(true)"></button>
        </div>
        <div class="snapshot" *ngIf="imageCaptured">
            <img [src]="webcamImage.imageAsDataUrl" />
            <div *ngIf="fencingError" style="color: red; font-weight: bold; margin-top:10px;">
                {{fencingError}}
            </div>
        </div>
        <div class="webcam-btn" *ngIf="imageCaptured">
            <button pButton pRipple type="button" label="Upload" class="p-button-success m-2"
                (click)="uploadPicture()" [disabled]="!isInsideFencing"></button>
            <button pButton pRipple type="button" label="Retake" class="p-button-success m-2"
                (click)="retake()"></button>
        </div>
    </div>
</p-dialog>